import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { FavoriteClientsResponse, GetFavoriteClientsParams } from 'src/types/favorite';
import axiosInstance from 'src/utils/axios';

export async function fetchFavoriteClients(
  params: GetFavoriteClientsParams
): Promise<FavoriteClientsResponse> {
  const response = await axiosInstance.get<FavoriteClientsResponse>(
    api.getFavoriteClients(params.companyId, params.isCopy, params.folderId)
  );
  return response.data;
}

const useGetFavoriteClientsQuery = (
  params: GetFavoriteClientsParams | null,
  enabled = true
) =>
  useQuery<FavoriteClientsResponse>({
    queryKey: queryKeys.favorite.clients(
      params?.companyId ?? 0,
      params?.isCopy ?? false,
      params?.folderId
    ),
    queryFn: () => {
      if (!params) {
        throw new Error('Missing GetClients parameters.');
      }
      return fetchFavoriteClients(params);
    },
    enabled: enabled && params != null && Number.isFinite(params.companyId),
  });

export default useGetFavoriteClientsQuery;
